export const routes = [
    {
        groupName: 'menu-1',
        routes: [
            {
                menuId: 'RPT-LIS200',
                menuName: 'Report Legacy Monitoring',
                pathname: '/legacyreport',
            },
            {
                menuId: 'RPT-LIS202',
                menuName: 'Report Legacy Task Monitoring',
                pathname: '/legacytask',
            },
        ]
    },
    {
        groupName: 'menu-2',
        routes: [
            {
                menuId: 'ADM-LIS311',
                menuName: 'Employee Config',
                pathname: '/employee',
            },
        ]
    }
];

export const flatRoutes = routes.flatMap(routeGroup => routeGroup.routes);
